import classNames from 'classnames'
import { useIsAuth } from 'feature/auth/hooks'
import {
  BannerSlider,
  HowWork,
  InfBlock,
  LoginBlock,
  OrderBlock,
} from 'feature/mainPage'
import { ScreenEnum, useScreen } from 'feature/screenMode'
import { UserData } from 'feature/user/components'
import { useGetMainPageDataQuery } from 'feature/user/redux/user.api'
import { MainLayout } from 'layouts'
import { Loading } from 'router/Loading'
import { useState } from 'react'
import { useAppSelector } from 'store/hooks'
import { UserTypeSelectionModal } from 'widget/UserTypeSelectionModal'

import style from './MainPage.module.scss'

export function MainPage() {
  const isAuth = useIsAuth()
  const screen = useScreen()
  const authInfo = useAppSelector(state => state.auth.authInfo)
  const { data, isLoading: userDataLoading } = useGetMainPageDataQuery(
    undefined,
    {
      skip: !isAuth,
    },
  )
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)

  if (authInfo.isLoading || userDataLoading)
    return (
      <MainLayout>
        <Loading />
      </MainLayout>
    )

  return (
    <MainLayout>
      <div className='container pt24'>
        <div className={classNames('flex', style.headerWrap)}>
          <h1 className={classNames('m0', style.header)}>
            Личный кабинет покупателя
          </h1>
        </div>

        {isAuth && screen !== ScreenEnum.mobile && data && (
          <UserData className={style.userData} data={data} />
        )}

        <div
          className={classNames(style.wrap, {
            [style.wrap_authenticated]: isAuth,
          })}
        >
          <div className={style.leftCol}>
            <BannerSlider />
            {/* {isAuth && <OrdersList />} */}
          </div>
          <div className={style.rightCol}>
            {!isAuth && (
              <LoginBlock onLoginClick={() => setIsLoginModalOpen(true)} />
            )}
            <OrderBlock isUserExist={isAuth} />
          </div>
        </div>

        <HowWork className={classNames('mobile-hidden', style.howWork)} />

        <InfBlock />
      </div>

      <UserTypeSelectionModal
        open={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
      />
    </MainLayout>
  )
}
